import * as FullStory from '@fullstory/browser';

function getEnvironment() {
  const host = window.location.host;
  if (host.includes('sdk.katapult.com')) return 'prod';
  if (host.includes('sandbox')) return 'sandbox';
  return 'dev';
}

function fullStoryOfferPageInit({ partnerName, firstName, customerPhone, uid }, attempt = 0) {
  const MAX_RETRIES = 3;
  const RETRY_DELAY_MS = 1000;

  try {
    const sessionVars = {
      uid_str: uid || 'unknown',
      displayName: `${firstName || ''} ${customerPhone || ''}`.trim() || 'unknown',
      partner_name_str: partnerName || 'unknown',
      flow_name_str: 'START_AT_OFFER_PAGE',
      phone_str: customerPhone || 'unknown',
      environment_str: getEnvironment(),
    };
    if (customerPhone) {
      FullStory.identify(customerPhone, sessionVars);
    } else {
      FullStory.setUserVars(sessionVars);
    }
  } catch (err) {
    if (attempt < MAX_RETRIES) {
      setTimeout(
        () => fullStoryOfferPageInit({ partnerName, firstName, customerPhone, uid }, attempt + 1),
        RETRY_DELAY_MS * 2 ** attempt,
      );
    } else {
      // eslint-disable-next-line no-console
      console.log('FullStory not loaded');
    }
  }
}

export default fullStoryOfferPageInit;
